<!-- Global Language Switcher - Header Style -->
<div class="global-language-header" [ngClass]="themeClasses">
    <div class="language-header-container">

        <!-- All Languages Displayed Horizontally -->
        <div class="language-tabs">
            <button *ngFor="let lang of supportedLanguages; trackBy: trackByLanguage" class="language-tab"
                [class.active]="currentLanguage === lang.code"
                [class.loading]="isLoading && loadingLanguage === lang.code" (click)="selectLanguage(lang.code)"
                [disabled]="isLoading" [attr.aria-current]="currentLanguage === lang.code ? 'true' : 'false'"
                [attr.aria-label]="getLanguageAriaLabel(lang.name)">

                <!-- Flag -->
                <img [src]="lang.flag" [alt]="lang.code" class="flag-icon" />

                <!-- Language Name -->
                <span class="language-name">{{ lang.name }}</span>

                <!-- Loading Spinner -->
                <ion-spinner *ngIf="isLoading && loadingLanguage === lang.code" name="crescent"
                    class="loading-spinner"></ion-spinner>
            </button>
        </div>
    </div>
</div>
